import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatWeekRange } from './WeekNavigator';

const SpinnerIcon = () => (
  <svg className="w-4 h-4 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 0 1 8-8v4a4 4 0 0 0-4 4H4z" />
  </svg>
);

function CopyWeekConfirmModal({ open, collisionWeeks, inFlight, onReplace, onCancel }) {
  const { t } = useTranslation('scheduler');

  if (!open) return null;

  return (
    <>
      <div
        className="fixed inset-0 z-[70] bg-black/40"
        aria-hidden="true"
        onClick={inFlight ? undefined : onCancel}
      />
      <div className="fixed inset-0 z-[80] flex items-center justify-center p-4" role="dialog" aria-modal="true">
        <div className="bg-white rounded-xl shadow-xl w-full max-w-sm p-6">
          <h2 className="text-base font-semibold text-gray-900 mb-2">
            {t('copyWeek.confirm.title')}
          </h2>
          <p className="text-sm text-gray-600 mb-3">
            {t('copyWeek.confirm.description')}
          </p>

          <ul className="mb-5 rounded-lg bg-amber-50 border border-amber-200 px-3.5 py-2.5 text-sm text-amber-800 space-y-1">
            {(collisionWeeks || []).map((ws) => (
              <li key={ws}>{formatWeekRange(new Date(`${ws}T00:00:00`))}</li>
            ))}
          </ul>

          <div className="flex flex-col gap-2">
            <button
              type="button"
              disabled={inFlight}
              onClick={onReplace}
              className="w-full inline-flex items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-orange-500 to-amber-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm shadow-orange-200 hover:from-orange-600 hover:to-amber-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              {inFlight && <SpinnerIcon />}
              {t('copyWeek.confirm.replace')}
            </button>

            <button
              type="button"
              disabled={inFlight}
              onClick={onCancel}
              className="w-full rounded-lg px-4 py-2 text-sm font-medium text-gray-500 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              {t('copyWeek.confirm.cancel')}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default CopyWeekConfirmModal;
